<div class="row final-page">
    <div class="col-12">
        <h2 [innerHTML]="'dynamische_frontend_texte.danke.html_content.ueberschrift' | translate | safeStyle"></h2>
    </div>

    <div class="col-12">
        <p [innerHTML]="'dynamische_frontend_texte.danke.html_content.line1' | translate | safeStyle"></p>
    </div>

    <div class="col-12">
        <p [innerHTML]="'dynamische_frontend_texte.danke.html_content.line2' | translate | safeStyle"></p>
    </div>
</div>
